module.exports = __webpack_public_path__ + "static/img/female-bg-tr.9eb5e30e.png";